import { LinkButton } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './DailyrentBanner.css';

export interface IDailyrentBannerProps {
  url: string;
  onClick(): void;
}

export function DailyrentBanner(props: IDailyrentBannerProps) {
  return (
    <div className={styles['banner']} data-name="DailyrentBanner">
      <div className={styles['info']}>
        <div className={styles['header']}>
          Откройте Россию заново
          <br />
          с&nbsp;путеводителем Циана
        </div>
        <div className={styles['button']}>
          <LinkButton theme="fill_white_primary" size="L" href={props.url} onClick={props.onClick}>
            Подробнее
          </LinkButton>
        </div>
      </div>
    </div>
  );
}
